import { createSelector } from 'reselect';

const stableObject = {};

const mostRecentMessageReceivedSelector = (chatHistory) =>
  createSelector(chatHistory, (chatHistory) => {
    const emails = (chatHistory.filter((item) => item.type === 'emails') || []).filter((item) => item.event_status !== 'draft').slice(-1)[0];
    const emailCopy = { ...emails };
    const texts = chatHistory.filter((n) => n.type === 'texts' && !['reviewloop'].includes((n.platform || {}).code)).slice(-1)[0];
    const calls = chatHistory.filter((n) => n.type === 'phone_calls').slice(-1)[0];
    if (emails) {
      emailCopy.platformRegistrationId = emails.platform_registration_id;
    }
    return { emails: emailCopy, texts, calls } || stableObject;
  });

export { mostRecentMessageReceivedSelector };
